<template>
  <div class="">
    <div class="case-pice">
      <span class="case-pice-first">学员信息</span>
      <span class="case-pice-and">/</span>
      <span class="case-pice-second">查看学员信息</span>
    </div>
    <div class="common-title">
      查看基本信息
      <el-button style="float: right" size="small" type="info" @click="goBack()" plain>返回</el-button>
    </div>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">学员姓名：</div>
          <el-input disabled v-model="StudentDetail.name" clearable class="grid-input" size="small"
            placeholder=""></el-input>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">性别：</div>
          <el-select disabled size="small" class="grid-input" v-model="StudentDetail.sex" clearable placeholder="">
            <el-option v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">手机号码：</div>
          <el-input disabled v-model="StudentDetail.phone" clearable class="grid-input" size="small"
            placeholder=""></el-input>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">培训类别：</div>
          <el-select size="small" class="grid-input" disabled v-model="StudentDetail.trainingClasses" clearable
            placeholder="">
            <el-option v-for="item in tarinTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">专业类别：</div>
          <el-select disabled size="small" class="grid-input" clearable v-model="StudentDetail.professionalClasses"
            placeholder="">
            <el-option v-for="(item, index) in majorCategoryList" :key="index" :label="item.codeCname"
              :value="item.codeCode">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">培训人员：</div>
          <el-select size="small" disabled class="grid-input" v-model="StudentDetail.trainers" clearable placeholder="">
            <el-option v-for="item in trainersList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">证件类型：</div>
          <el-select disabled size="small" class="grid-input" v-model="StudentDetail.idType" clearable placeholder="">
            <el-option v-for="item in cardTypeList" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">证件号码：</div>
          <el-input disabled v-model="StudentDetail.idCard" clearable class="grid-input" size="small"
            placeholder=""></el-input>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">学历：</div>
          <el-select size="small" class="grid-input" disabled v-model="StudentDetail.education" clearable
            placeholder="">
            <el-option v-for="(item, index) in educationList" :key="index" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">健康状况：</div>
          <el-select size="small" class="grid-input" disabled v-model="StudentDetail.healthState" clearable
            placeholder="">
            <el-option v-for="item in healthList" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">出生日期：</div>
          <div style="flex: 1">
            <el-date-picker size="small" style="width: 100%" disabled v-model="StudentDetail.birthday" type="date"
              placeholder=""></el-date-picker>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">民族：</div>
          <div style="flex: 1">
            <el-select size="small" class="common-full-width" disabled v-model="StudentDetail.nation" clearable
              placeholder="">
              <el-option v-for="item in nationList" :key="item.cc" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">专业技术职务：</div>
          <div style="flex: 1">
            <el-select size="small" class="common-full-width" disabled v-model="StudentDetail.technicalPosition"
              clearable placeholder="">
              <el-option v-for="item in technicalList" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">电子邮箱：</div>
          <el-input v-model="StudentDetail.email" clearable disabled class="grid-input" size="small"
            placeholder=""></el-input>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">受聘时间：</div>
          <div style="flex: 1">
            <el-date-picker size="small" style="width: 100%" disabled v-model="StudentDetail.employedDate" type="date"
              placeholder=""></el-date-picker>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">毕业院校：</div>
          <div style="flex: 1">
            <el-input v-model="StudentDetail.graduateSchool" disabled clearable class="common-full-width" size="small"
              placeholder=""></el-input>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">毕业时间：</div>
          <div style="flex: 1">
            <el-date-picker size="small" style="width: 100%" disabled v-model="StudentDetail.graduationDate" type="date"
              placeholder=""></el-date-picker>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">通讯地址：</div>
          <div style="flex: 1">
            <el-input v-model="StudentDetail.homeAddress" clearable disabled class="common-full-width" size="small"
              placeholder=""></el-input>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">专业：</div>
          <div style="flex: 1">
            <el-input v-model="StudentDetail.major" clearable disabled class="common-full-width" size="small"
              placeholder=""></el-input>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">学位：</div>
          <div style="flex: 1">
            <el-select size="small" class="common-full-width" disabled v-model="StudentDetail.degree" clearable
              placeholder="">
              <el-option v-for="item in degreeList" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">考试科目：</div>
          <div style="flex: 1">
            <el-select size="small" class="common-full-width" disabled v-model="StudentDetail.examSubject" clearable
              placeholder="">
              <el-option v-for="item in examSubjectList" :key="item.code" :label="item.name" :value="item.code">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">证书邮寄地址：</div>
          <div style="flex: 1">
            <el-input v-model="StudentDetail.mailingAddress" disabled clearable class="common-full-width" size="small"
              placeholder=""></el-input>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">收件人：</div>
          <div style="flex: 1">
            <el-input v-model="StudentDetail.recipients" disabled clearable class="common-full-width" size="small"
              placeholder=""></el-input>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">联系电话：</div>
          <div style="flex: 1">
            <el-input v-model="StudentDetail.recipientsPhone" disabled clearable class="common-full-width" size="small"
              placeholder=""></el-input>
          </div>
        </div>
      </el-col>
    </el-row> -->
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label" style="width: 200px">
            累计从事道路运输工作年限：
          </div>
          <div style="flex: 1">
            <el-input v-model="StudentDetail.yearsOfWorking" disabled clearable class="common-full-width" size="small"
              placeholder=""></el-input>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div class="grid-label">导入时间：</div>
          <div style="flex: 1">
            <el-date-picker size="small" style="width: 100%" disabled v-model="StudentDetail.importTime" type="datetime"
              placeholder=""></el-date-picker>
          </div>
        </div>
      </el-col>
      <el-col :span="8"> </el-col>
    </el-row>

    <div class="common-title">证件照片</div>
    <el-row :gutter="40" id="imgTooles1">
      <el-col :span="8">
        <div class="grid-img" id="imgTooles" style="position: relative; border: 1px solid #cccccc">
          <img @click="preImage2()" :src="StudentDetail.personImg" :data-original="StudentDetail.personImg" alt="" />
          <i v-if="StudentDetail.personImg != ''" class="el-icon-circle-close img-close-icon"
            @click="deleteImg('personImg')"></i>
        </div>
        <div style="text-align: center; margin-top: 10px">
          <el-upload :headers="$util.getUploadHeaders()" :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess" :action="actionUrl" :show-file-list="false">
            <el-button size="small" type="primary">{{ buttonText }}</el-button>
          </el-upload>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-img" id="imgTooles" style="position: relative; border: 1px solid #cccccc">
          <img @click="preImage2()" :src="StudentDetail.idCardFrontImg" :data-original="StudentDetail.idCardFrontImg"
            alt="" />
          <i v-if="StudentDetail.idCardFrontImg != ''" class="el-icon-circle-close img-close-icon"
            @click="deleteImg('idCardFrontImg')"></i>
        </div>
        <!--<div style="text-align: center;margin-top: 10px;">
					<el-upload :before-upload="beforeAvatarUpload" :on-success="handleFrontSuccess" :action='actionUrl' :show-file-list='false'>
						<el-button size="small" type="primary">上传证件正面照</el-button>
					</el-upload>
				</div>-->
      </el-col>
      <el-col :span="8">
        <div class="grid-img" id="imgTooles" style="position: relative; border: 1px solid #cccccc">
          <img @click="preImage2()" :src="StudentDetail.idCardBackImg" :data-original="StudentDetail.idCardBackImg"
            alt="" />
          <i v-if="StudentDetail.idCardBackImg != ''" class="el-icon-circle-close img-close-icon"
            @click="deleteImg('idCardBackImg')"></i>
        </div>
        <!--<div style="text-align: center;margin-top: 10px;">
					<el-upload :before-upload="beforeAvatarUpload" :on-success="handleBackSuccess" :action='actionUrl' :show-file-list='false'>
						<el-button size="small" type="primary">上传证件背面照</el-button>
					</el-upload>
				</div>-->
      </el-col>
    </el-row>
    <!-- <div class="common-title">工作经历</div>
    <div v-for="(item, index) in StudentDetail.workHistory" :key="index">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content company-title">
            {{ item.company }}
            <span style="margin-left: 30px" class="company-text">{{ item.workStartTime }}至 {{ item.workEndTime }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content company-text">
            部门：{{ item.department }}
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content company-text">职位：{{ item.position }}</div>
        </el-col>
      </el-row>
      <div>
        <div class="grid-content company-text">职责描述</div>
        <div style="line-height: 30px">
          {{ item.workContent }}
        </div>
      </div>
    </div> -->
    <div class="common-title">培训记录</div>
    <div v-for="(item, index) in StudentDetail.trainingHistory" :key="index">
      <el-row :gutter="20">
        <el-col :span="24">
          <span>
            <span class="grid-content">
              <span class="company-title" style="padding-right: 10px">{{ item.companyName }}
              </span>
              <el-button type="primary" size="mini" @click="compileData(item)">编辑学时</el-button>
            </span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="4">
          <div class="grid-content company-text">
            培训状态：
            <span v-if="item.trainingStatus == 1">培训中</span>
            <span v-if="item.trainingStatus == 2">结业</span>
            <span v-if="item.trainingStatus == 3">考核中</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content company-text">
            培训类别：
            <span v-if="item.trainingClasses == 1">初次培训</span>
            <span v-if="item.trainingClasses == 2">继续教育</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content company-text">
            专业类别：{{ item.professionalClasses }}
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content company-text">
            培训人员：
            <span v-if="item.trainers == 1">负责人</span>
            <span v-if="item.trainers == 2">安全管理人员</span>
            <span v-if='item.trainers == 3'>动态监控</span>
					  <span v-if='item.trainers == 4'>其他</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content company-text">
            学时：
            {{ item.period }}
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content company-text">
            培训时间：
            {{ item.pxTime }}  {{item.pxEndTime?"至 " + item.pxEndTime: ''}}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="common-title" style="display: flex">
      <div style="width: 150px; color: #409eff; font-size: 20px !important">
        考核记录
      </div>
      <div style="text-align: right; flex: 1">
        <span style="color: rgb(8, 189, 42); margin-right: 20px; cursor: pointer" @click="addData()">+ 新增考核记录</span>
        <span style="color: #c31818; cursor: pointer" @click="deleteData()">- 删除</span>
      </div>
    </div>
    <el-table :row-key="getRowKeys" :data="tableData" border style="width: 100%" stripe height=" calc(100vh - 220px)"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <!-- <el-table-column label="序号" width="60">
				<template slot-scope="scope">
					{{scope.$index+1}}
				</template>
</el-table-column> -->
      <el-table-column prop="examTime" min-width="200" show-overflow-tooltip label="考核时间">
      </el-table-column>
      <el-table-column prop="score" min-width="200" show-overflow-tooltip label="分数">
      </el-table-column>
      <el-table-column show-overflow-tooltip label="考核状态">
        <template slot-scope="scope">
          <span style="color: rgb(8, 189, 42)" v-if="scope.row.status == 1">通过</span>
          <span style="color: #c31818" v-else>未通过</span>
        </template>
      </el-table-column>
      <el-table-column min-width="180" prop="vaildTime" show-overflow-tooltip label="证书有效期">
        <template slot-scope="scope">
          <span>{{ scope.row.validStartTime }}</span> -
          <span>{{ scope.row.validEndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="corp" min-width="100" show-overflow-tooltip label="证书二维码">
        <template slot-scope="scope">
          <!-- <span @click="showImg()" style="color: #409EFF;cursor: pointer;"><img :src="nowUrl" id="hideImg"
							style="display: none;" />查看证书</span> -->
          <div :id="'imgToolesaaa' + scope.$index" @click="preImage3(scope.$index)"
            style="text-align: center; cursor: pointer">
            <img style="
                display: inline-block;
                height: 50px;
                width: 50px;
                margin-top: 6px;
              " :data-original="scope.row.url" :src="scope.row.url" alt="" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" min-width="160" show-overflow-tooltip label="下载证书二维码">
        <template slot-scope="scope">
          <span style="color: #409eff; cursor: pointer" @click="dowmloadImg(scope.row.url)">下载证书二维码</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230">
        <template slot-scope="scope">
          <span style="color: rgb(8, 189, 42); cursor: pointer" @click="editData(scope.row)">编辑考核记录信息</span>
          <!-- <el-button size='mini' type="primary" @click='goMemberInfo("update",scope.row)' plain>编辑</el-button>
					<el-button size='mini' type="danger" @click='deleteMember(scope.row)' plain>删除</el-button>
					<el-button size='mini' type="info" @click='goMemberInfo("look",scope.row)' plain>查看</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNumber">
      </el-pagination>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogSearchModel" v-if="dialogSearchModel" width="40%">
      <div style="display: flex">
        <div style="display: flex; flex: 1">
          <div class="commom-input-label-short">考核时间</div>
          <div class="common-full-width-style">
            <el-date-picker size="small" style="width: 100%" v-model="examTime" type="date"
              placeholder="选择考核时间"></el-date-picker>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div style="display: flex; flex: 1">
          <div class="commom-input-label-short">分数</div>
          <div class="common-full-width-style">
            <el-input :max="100" :min="0" v-model="score" @input="changeInput" type="number" clearable
              class="common-full-width" size="small" placeholder="请输入分数"></el-input>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div style="display: flex; flex: 1">
          <div class="commom-input-label-short">考核状态</div>
          <div class="common-full-width-style">
            <el-select disabled size="small" class="common-full-width" v-model="status" clearable placeholder="请输入分数">
              <el-option v-for="item in throughList" :key="item.type" :label="item.name" :value="item.type">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div style="display: flex; flex: 1">
          <div class="commom-input-label-short">证书有效期</div>
          <div class="common-full-width-style">
            <el-date-picker size="small" style="width: 100%" v-model="validStartTime" type="date"
              placeholder="选择生效日期"></el-date-picker>
          </div>
          <div class="common-full-width-style">
            <el-date-picker size="small" style="width: 100%" v-model="validEndTime" type="date"
              placeholder="选择失效日期"></el-date-picker>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div style="display: flex; flex: 1">
          <div class="commom-input-label-short">上传证书二维码</div>
          <div class="common-full-width-style">
            <div style="
                width: 120px;
                height: 120px;
                border: 1px solid #eeeeee;
                position: relative;
                overflow: hidden;
              ">
              <i v-if="url != ''" class="el-icon-circle-close img-close-icon" @click="deleteImg('CertificateUrl')"></i>
              <img @click="preImage()" :src="url" id="member-view" style="width: 100%; height: auto" alt=""
                :data-original="url" />
            </div>
            <el-upload :headers="$util.getUploadHeaders()" :before-upload="beforeAvatarUpload"
              :on-success="handlePersonSuccess" :action="actionUrl" :show-file-list="false">
              <el-button size="small" type="primary">上传图片</el-button>
            </el-upload>
            <span style="color: #ccc; font-size: 14px">文件拓展名：.png .jpg</span>
          </div>
        </div>
      </div>
      <div style="text-align: center; height: 50px; line-height: 50px">
        <el-button size="small" type="info" @click="dialogSearchModel = false" plain>取消</el-button>
        <el-button size="small" type="primary" @click="saveData()">保存</el-button>
      </div>
    </el-dialog>
    <div id="ceshi" style="height: 200px; display: none">
      <img style="height: 100%; width: 100%"
        src="https://dlysxh-images.oss-cn-beijing.aliyuncs.com/2020/12/10/1336923125895532544013362356546438471680tmp_c82adc6293642bb7a56ed9230a9cb69978531bd494959265_看图王.jpg"
        alt="" />
    </div>
    <!--  编辑学时 -->
    <el-dialog title="编辑学员学时信息" :visible.sync="dialogVisible" width="30%" center :before-close="handleClose"
      class="upload-dialog">
      <el-form ref="form" :model="durationData" label-width="80px" :rules="rules">
        <el-form-item label="培训时间" prop="pxTimeRange">
          <!-- <el-date-picker type="date" placeholder="选择日期" v-model="durationData.pxTime" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"></el-date-picker> -->
            <el-date-picker
            v-model="durationData.pxTimeRange"
            style="width: 240px"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学习时长" prop="period">
          <el-input v-model="durationData.period"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="logisticeSave()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStudentDetail,
  majorTypeList,
  personImg,
  getExmaList,
  addExam,
  editExam,
  deleteExam,
  studentUpdate,
} from "../../api/main";
import Viewer from "viewerjs";
import { fchownSync } from "fs";
export default {
  data() {
    return {
      throughList: [
        {
          name: "通过",
          type: "1",
        },
        {
          name: "未通过",
          type: "0",
        },
        {
          name: "缺考",
          type: "2",
        },
      ],
      searchData: {},
      dialogSearchModel: false,
      tableData: [],
      StudentDetail: {},
      actionUrl: "https://daoxie.hellouxing.com/api/v1/uploadMaterial",
      //				actionUrl: 'http://19940309.xyz:20005/api/v1/uploadMaterial',
      buttonText: "",
      healthList: [
        {
          value: "1",
          name: "严重",
        },
        {
          value: "2",
          name: "一切正常",
        },
        {
          value: "3",
          name: "状况欠佳",
        },
      ],
      sexList: [
        {
          label: "男",
          value: "0",
        },
        {
          label: "女",
          value: "1",
        },
      ],
      tarinTypeList: [
        {
          label: "初次培训",
          value: "1",
        },
        {
          label: "继续教育",
          value: "2",
        },
      ],
      majorCategoryList: [],
      trainersList: [
        {
          label: "负责人",
          value: "1",
        },
        {
          label: "安全管理人员",
          value: "2",
        },
         {
					label: '动态监控',
					value: "3"
				}, {
					label: '其他',
					value: "4"
				}
      ],
      nowSelectDataList: [],
      nowUrl: "",
      CertificateData: {
        CertificateUrl: "",
      },
      actionUrl: "",
      //				actionUrl: 'http://19940309.xyz:20005/api/v1/uploadMaterial',
      rulesList: [
        {
          name: "考试时间",
          str: "examTime",
          type: 1,
        },
        {
          name: "分数",
          str: "score",
          type: 1,
        },

        {
          name: "证书生效日期",
          str: "validStartTime",
          type: 1,
        },
        {
          name: "证书失效日期",
          str: "validEndTime",
          type: 1,
        },
      ],
      examTime: "",
      score: "",
      status: 1,
      validStartTime: "",
      validEndTime: "",
      url: "",
      currentPage: 1,
      pageSize: 10,
      totalNumber: 0,
      dialogTitle: "",
      editId: "",
      dialogVisible: false, //学时弹窗
      durationData: {}, //上传学时需要的数据
      mId: "",
      rules: {
        pxTimeRange: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        period: [
          { required: true, message: "请输入学习时长", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    score(value) {
      if (value < 0) {
        this.score = 0;
      }
      if (value > 100) {
        this.score = 100;
      }
    },
  },
  mounted() {
    this.actionUrl = `${this.$httpUrl}/api/v1/uploadMaterial`;
    this.getStudentDetailFn();
    this.getMajorDataList();
  },
  computed: {
    educationList() {
      let educationList = JSON.parse(sessionStorage.getItem("educationList"));
      return educationList;
    },
    cardTypeList() {
      let cardTypeList = JSON.parse(sessionStorage.getItem("cardTypeList"));
      cardTypeList.shift();
      return cardTypeList;
    },
    nationList() {
      let nationList = JSON.parse(sessionStorage.getItem("nationList"));
      nationList.shift();
      return nationList;
    },
    technicalList() {
      let technicalList = JSON.parse(sessionStorage.getItem("technicalList"));
      technicalList.shift();
      return technicalList;
    },
    degreeList() {
      let degreeList = JSON.parse(sessionStorage.getItem("degreeList"));
      degreeList.shift();
      return degreeList;
    },
    examSubjectList() {
      let examSubjectList = JSON.parse(
        sessionStorage.getItem("examSubjectList")
      );
      examSubjectList.shift();
      return examSubjectList;
    },
  },
  methods: {
    changeInput(value) {
      console.log(value);
      if (value == 0) {
        this.status = "2";
      } else if (value > 0 && value < 80) {
        this.status = "0";
      } else {
        this.status = "1";
      }
    },
    dowmloadImg(url) {
      window.open(url);
    },
    getRowKeys(row) {
      return row.id;
    },
    handleSizeChange(data) {
      this.pageSize = data;
      this.getTableList();
    },
    handleCurrentChange(data) {
      this.currentPage = data;
      this.getTableList();
    },
    getTableList() {
      getExmaList({
        current: this.currentPage,
        pageSize: this.pageSize,
        applicationFormId: this.$route.query.applicationFormId,
        studentId: this.StudentDetail.studentId,
      }).then((res) => {
        console.log(res);
        this.totalNumber = parseInt(res.data.total);
        let arr =[];
        for (let index = 0;  index< res.data.records.length; index++) {
          const element = res.data.records[index];
          element.examTime = this.formatTime(element.examTime)
          element.validEndTime = this.formatTime(element.validEndTime )
          element.validStartTime = this.formatTime(element.validStartTime )
          arr.push(element)
        }
        this.tableData = arr;
      });
      this.tableData = [];
    },
    formatTime(vl){
      return vl.replace(/ \d+(:\d+){2}/,'');
    },

    saveData() {
      let that = this;
      let flag = null;
      flag = this.rulesList.find(function (value) {
        if (!that[value.str]) return value;
      });
      if (flag) {
        let type;
        let type1 =
          flag.type == 1 && this.language != "en" ? "请输入" : "请选择";
        let type2 =
          flag.type == 1 && this.language == "en"
            ? "Please select "
            : "Please enter ";
        if (this.language && this.language == "en") {
          this.$message.error(`${type2}${flag.englishName}`);
        } else {
          this.$message.error(`${type1}${flag.name}`);
        }
        return;
      }
      if (this.status == "") {
        this.$message.error(`请选择证书状态`);
        return;
      }
      if (this.url == "") {
        this.$message.error(`请上传学员证件照`);
        return;
      }
      let a = this.$moment(`${this.validStartTime}`);
      let b = this.$moment(this.validEndTime);
      let diff = a.diff(b, "hours", true);
      if (diff > 0) {
        this.$message.error(`生效日期需小于失效日期`);
        return;
      }
      this.validStartTime = this.$moment(this.validStartTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.validEndTime = this.$moment(this.validEndTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.examTime = this.$moment(this.examTime).format("YYYY-MM-DD HH:mm:ss");
      if (this.dialogTitle == "新增考核记录") {
        addExam({
          examTime: this.examTime,
          score: this.score,
          status: this.status,
          validStartTime: this.validStartTime,
          validEndTime: this.validEndTime,
          url: this.url,
          applicationFormId: this.$route.query.applicationFormId,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("新增成功！");
            this.getTableList();
            this.dialogSearchModel = false;
          } else {
            this.$message.error(res.msg);
            this.dialogSearchModel = false;
          }
        });
      } else if (this.dialogTitle == "修改考核记录") {
        editExam({
          id: this.editId,
          examTime: this.examTime,
          score: this.score,
          status: this.status,
          validStartTime: this.validStartTime,
          validEndTime: this.validEndTime,
          url: this.url,
          applicationFormId: this.$route.query.applicationFormId,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("修改成功！");
            this.getTableList();
            this.dialogSearchModel = false;
          } else {
            this.$message.error(res.msg);
            this.dialogSearchModel = false;
          }
        });
      }
    },
    handlePersonSuccess(res, file) {
      this.url = res.data;
    },
    addData() {
      this.editId = "";
      this.examTime = "";
      this.score = "";
      this.status = "";
      this.validStartTime = "";
      this.validEndTime = "";
      this.url = "";
      this.dialogSearchModel = true;
      this.dialogTitle = "新增考核记录";
    },
    editData(row) {
      this.dialogSearchModel = true;
      this.dialogTitle = "修改考核记录";
      this.editId = row.id;
      this.examTime = row.examTime;
      this.score = row.score;
      this.status = row.status;
      this.validStartTime = row.validStartTime;
      this.validEndTime = row.validEndTime;
      this.url = row.url;
    },
    deleteData() {
      if (this.nowSelectDataList.length == 0) {
        this.$message.error("请选择您想要删除的考核记录");
        return;
      }
      let list = [];
      this.nowSelectDataList.forEach((item) => {
        list.push(item.id);
      });
      this.$confirm("确定要删除所选数据吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteExam(list).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功！");
              this.getTableList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          // 	type: 'info',
          // 	message: '已取消结业操作'
          // });
        });
    },
    showImg() {
      this.nowUrl =
        "https://dlysxh-images.oss-cn-beijing.aliyuncs.com/2021/05/30/13989108424388157440SssentfhNbv55dbf96b9595af156794f328ee9c79a7f.jpg";
      let ViewerDom = document.getElementById("ceshi");
      let image = new Viewer(ViewerDom, {
        url: "data-original",
        zoomable: true,
        movable: true,
        backdrop: true,
        zoomRatio: 0.4, //鼠标滚动时的缩放比例
        tooltip: true,
        toolbar: true,
        fullscreen: false,
        button: true,
      });
      image.view();
    },
    aaaaa() { },
    handleSelectionChange(data) {
      this.nowSelectDataList = data;
    },
    getMajorDataList() {
      majorTypeList({
        current: 1,
        pageSize: 30,
        professionalName: "",
      }).then((res) => {
        this.majorCategoryList = res.data.records;
      });
    },
    preImage3(index) {
      console.log(index);
      const ViewerDom = document.getElementById("imgToolesaaa" + index);
      const viewer = new Viewer(ViewerDom, {
        url: "data-original",
      });
    },
    preImage() {
      const ViewerDom = document.getElementById("member-view");
      const viewer = new Viewer(ViewerDom, {
        url: "data-original",
      });
    },
    preImage2() {
      const ViewerDom = document.getElementById("imgTooles1");
      const viewer = new Viewer(ViewerDom, {
        url: "data-original",
      });
    },
    deleteImg(url) {
      if (url == "personImg") {
        this.StudentDetail.personImg = "";
        personImg({
          personImg: this.StudentDetail.personImg,
          studentId: this.StudentDetail.studentId,
        }).then((res) => {
          this.$message.success("删除成功");
        });
      } else if (url == "CertificateUrl") {
        this.url = "";
      }
    },
    handleAvatarSuccess(res, file) {
      this.StudentDetail.personImg = res.data;
      personImg({
        personImg: this.StudentDetail.personImg,
        studentId: this.StudentDetail.studentId,
      }).then((res) => {
        this.$message.success("上传成功");
      });
    },
    handleFrontSuccess(res, file) {
      this.StudentDetail.idCardFrontImg = res.data;
    },
    handleBackSuccess(res, file) {
      this.StudentDetail.idCardBackImg = res.data;
    },
    beforeAvatarUpload(file) {
      let isJPG = file.type;
      let isLt2M = file.size / 1024 / 1024 < 0.2;
      // if (!isLt2M) {
      // 	this.$message.error("照片过大，请将图片大小压缩至200kb以下");
      // 	isLt2M = false;
      // } else {
      // 	isLt2M = true;
      // }
      if (
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/JPG" ||
        file.type == "image/PNG"
      ) {
        isJPG = true;
      } else {
        this.$message.error("上传头像图片只能是JPG或者PNG格式!");
        isJPG = false;
      }
      if (isJPG) {
        return true;
      } else {
        return false;
      }
    },
    getStudentDetailFn() {
      getStudentDetail(this.$store.state.studentId).then((res) => {
        this.StudentDetail = res.data;
        this.getTableList();
        if (res.data.personImg == "") {
          this.buttonText = "学员照片上传";
        } else {
          this.buttonText = "学员照片重新上传";
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    search() { },
    // X 关闭
    handleClose() {
      this.dialogVisible = false;
    },
    // 打开编辑学时弹窗
    compileData(vl) {
      console.log(vl);
      this.mId = vl.applicationFormId;
      this.dialogVisible = true;
    },
    //保存编辑学时
    logisticeSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.durationData.pxTime = this.durationData.pxTimeRange[0];
          this.durationData.pxEndTime = this.durationData.pxTimeRange[1];
          this.durationData.applicationFormId = this.mId;
          delete this.durationData.pxTimeRange
          studentUpdate(this.durationData).then((res) => {
            if (res.code == 1) {
              this.$message.success("修改成功");
              this.handleClose();
              this.getStudentDetailFn();
              this.reset()
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 表单重置
    reset() {
      this.durationData = {
        pxTime: undefined,
        pxEndTime: undefined,
        period: undefined,
        pxTimeRange: [],
      };
      this.resetForm("durationData");
    },

  },
};
</script>

<style lang="less">
.company-change-detail {
  font-size: 16px;
}

.upload-dialog {
  .el-dialog__header {
    .center-title .el-dialog__title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }

    background: white;

    .el-dialog__title {
      color: black;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: black;
    }
  }
}
</style>
